"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import styles from "./PricingFAQ.module.css";

const faqs = [
  {
    question: "Can I switch plans later?",
    answer: "Absolutely. You can upgrade or downgrade your plan at any time from your account settings. If you upgrade, the prorated difference will be applied to your next billing cycle.",
  },
  {
    question: "Are there any hidden setup fees?",
    answer: "No, we believe in transparent pricing. There are no setup fees, integration fees, or hidden charges on any of our standard plans.",
  },
  {
    question: "Do you offer a free trial?",
    answer: "Yes! All our plans come with a 14-day free trial so you can experience the full power of Moteligo before committing.",
  },
  {
    question: "What forms of payment do you accept?",
    answer: "We accept all major credit cards (Visa, Mastercard, American Express) and PayPal. For Enterprise plans, we can also arrange invoice-based wire transfers.",
  },
  {
    question: "Is there a discount for yearly billing?",
    answer: "Yes, you save 20% by paying annually instead of monthly. This discount is automatically applied when you select the Yearly billing option.",
  },
];

export default function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>Frequently Asked Questions</h2>
        <p className={styles.subtitle}>Have a question? We've got you covered.</p>
        
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`${styles.faqItem} ${openIndex === index ? styles.expanded : ""}`}
            >
              <button 
                className={styles.faqHeader} 
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <ChevronDown className={styles.icon} size={20} />
              </button>
              <div className={styles.faqContent}>
                <p className={styles.answer}>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
